import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import styled from 'styled-components/macro'

const LoyaltyBadgeAlt = createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_355_5361)">
      <path
        d="M6.00195 9C6.00195 10.5913 6.63409 12.1174 7.75931 13.2426C8.88453 14.3679 10.4107 15 12.002 15C13.5933 15 15.1194 14.3679 16.2446 13.2426C17.3698 12.1174 18.002 10.5913 18.002 9C18.002 7.4087 17.3698 5.88258 16.2446 4.75736C15.1194 3.63214 13.5933 3 12.002 3C10.4107 3 8.88453 3.63214 7.75931 4.75736C6.63409 5.88258 6.00195 7.4087 6.00195 9Z"
        stroke="var(--text-heading)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.002 15L15.402 20.89L17 17.657L20.598 17.889L17.198 12"
        stroke="var(--text-heading)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.80381 12L3.40381 17.89L7.00181 17.657L8.59981 20.889L11.9998 15"
        stroke="var(--text-heading)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_355_5361">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.00195312)"
        />
      </clipPath>
    </defs>
  </React.Fragment>,
  'LoyaltyBadgeAlt'
)

export default styled(LoyaltyBadgeAlt)`
  g {
    transform: translateX(3px) translateY(4px);
  }
`
